import React, { useEffect, useState } from "react"
import classNames from "classnames"
import { Select } from "antd"
import moment from "moment-timezone"
import { TIMEZONES } from "constants/timezones"

export const TimezoneSelect = ({ className, onChange, value }) => {
  const [userTimezone, setUserTimezone] = useState(null)

  useEffect(() => {
    const detectedTimezone = moment.tz.guess()
    const foundTimezone = TIMEZONES.find((tz) => tz.value === detectedTimezone)

    if (foundTimezone) {
      setUserTimezone(foundTimezone.value)
      if (onChange && !value) {
        onChange(foundTimezone.value)
      }
    } else {
      setUserTimezone(TIMEZONES[0].value)
      if (onChange && !value) {
        onChange(TIMEZONES[0].value)
      }
    }
  }, [onChange, value])

  let timezone = userTimezone
  if (TIMEZONES.find((tz) => tz.value === value)) {
    timezone = value
  }

  return (
    <Select
      className={classNames(className)}
      style={{ maxWidth: "430px", width: "100%" }}
      placeholder="Select a timezone"
      value={timezone}
      onChange={onChange}
      options={TIMEZONES}
    />
  )
}
